import axiosInstance from "../axios/axiosInstance";
import config from "./Config";

export default class ImageService {

    uploadAvatar(data, image) {
        return axiosInstance.post(`${config.api.version}/image/${data}/avatar`, image, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

    upload(data, image) {
        return axiosInstance.post(`${config.api.version}/image/${data}/upload`, image, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
    }

}
